export default __webpack_public_path__ + "static/media/streaks 20.f2839fff.svg";